import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AppointmentTypeAdvancedConfigForm } from "@/components/appointment/type/appointment-type-advanced-config-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetAppointmentTypeAdvancedConfigQuery = graphql(`
  query GetAppointmentTypeAdvancedConfigQuery($codUsuarioCompromisso: Int!) {
    appointmentType: usuariosCompromissos_by_pk(
      codUsuarioCompromisso: $codUsuarioCompromisso
    ) {
      ...AppointmentTypeAdvancedConfigFormFragment
    }
  }
`);

const AppointmentTypeAdvancedConfigPage = (): JSX.Element => {
  const router = useRouter();
  const params = Route.useParams();

  const queryResult = useGraphQL(GetAppointmentTypeAdvancedConfigQuery, {
    codUsuarioCompromisso: params.appointmentTypeId,
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={() => router.history.back()} />
        <HeaderTitle title="Configurações avançadas" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data && queryResult.isFetchedAfterMount ? (
            <AppointmentTypeAdvancedConfigForm appointmentType={data.appointmentType} />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config",
)({
  parseParams: (params) => ({
    appointmentTypeId: z.int().parse(Number(params.appointmentTypeId)),
  }),
  component: AppointmentTypeAdvancedConfigPage,
});
